import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';
import { PageMeta } from '../components/seo/PageMeta';

export function AboutPage() {
  const { t } = useTranslation();
  const blocks = useContentBlocks('staticPages.about.blocks');

  return (
    <>
    <PageMeta
      title="About Rocket Proxy | Buy Proxies"
      description="Rocket Proxy sells residential, mobile, ISP, and datacenter proxies plus phone numbers from one account, with instant delivery and 24/7 support."
      path="/about"
    />
    <StaticPageLayout titleKey="staticPages.about.title" subtitleKey="staticPages.about.subtitle">
      <ContentSections blocks={blocks} />
      <div className="pt-4">
        <Link
          to="/register"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-brand-accent text-white font-heading font-semibold text-sm"
        >
          {t('staticPages.about.cta')}
        </Link>
      </div>
    </StaticPageLayout>
    </>
  );
}
